/*
 * @Author: M.D.
 * @Date: 2020-01-13 09:48:09
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
import request from './axios'
// import _ from 'lodash'

export default {
  // 获取资讯列表
  getNewsListByType: params => {
    return request({
      url: 'base/pc/consultancy/list',
      method: 'get',
      params
    })
  },

  // 获取资讯详情
  getNewsDetail: newsId => {
    return request({
      url: `base/pc/consultancy/info/${newsId}`,
      method: 'get'
    })
  },

  // 获取积分列表明细
  getPointDetail: params => {
    return request({
      url: `member/memberPointRecord/getPointInfo`,
      method: 'get',
      params
    })
  },

  getAgreement: params => {
    return request({
      url: '/member/member/getAgreement',
      method: 'get',
      params
    })
  },

  getValidateCode: () => {
    return request({
      url: '/sys/api/user/getValidateCode',
      method: 'get'
    })
  }
}
